var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3389 1.93359H4.08639C3.95379 1.93359 3.82661 1.98627 3.73284 2.08004C3.63907 2.17381 3.58639 2.30099 3.58639 2.43359C3.58639 2.5662 3.63907 2.69338 3.73284 2.78715C3.82661 2.88092 3.95379 2.93359 4.08639 2.93359H12.3584L2.09889 13.1936C2.0493 13.2392 2.00944 13.2944 1.98173 13.3559C1.95401 13.4173 1.939 13.4837 1.93761 13.5511C1.93621 13.6185 1.94846 13.6855 1.9736 13.748C1.99875 13.8106 2.03628 13.8674 2.08395 13.915C2.13161 13.9627 2.18842 14.0002 2.25095 14.0254C2.31349 14.0505 2.38047 14.0628 2.44786 14.0614C2.51525 14.06 2.58166 14.045 2.6431 14.0173C2.70454 13.9895 2.75975 13.9497 2.80539 13.9001L13.0654 3.64009V11.9126C13.0654 12.0452 13.1181 12.1724 13.2118 12.2661C13.3056 12.3599 13.4328 12.4126 13.5654 12.4126C13.698 12.4126 13.8252 12.3599 13.9189 12.2661C14.0127 12.1724 14.0654 12.0452 14.0654 11.9126V2.66059C14.0651 2.46795 13.9885 2.28326 13.8523 2.147C13.7162 2.01073 13.5315 1.93399 13.3389 1.93359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreCompetitor);
export default __webpack_public_path__ + "static/media/ExploreCompetitor.adedb4a7d7c855a747fb5bb38aa35869.svg";
export { ForwardRef as ReactComponent };